import { FC } from 'react';
import { cva } from 'class-variance-authority';
import Tag from '@/shared/ui/Tag/Tag';
import Tags from '@/entities/Tags/Tags';
import clsx from 'clsx';
import Link from 'next/link';

interface Props {
  className?: string;
  activeTagId?: number;
  tags: Array<{
    id: number;
    title: string;
  }>;
}

export const ContestListTags: FC<Props> = ({
  className,
  activeTagId,
  tags,
}) => {
  return (
    <Tags className={clsx(cvaRoot(), className)}>
      {tags.map((el) => (
        <Link key={el.id} href={`#${el.id}`} prefetch={false}>
          <Tag theme={el.id === activeTagId ? 'active' : 'blurred'}>
            {el.title}
          </Tag>
        </Link>
      ))}
    </Tags>
  );
};

const cvaRoot = cva([
  'ContestListTags-cvaRoot',
  'mt-1.2 md-max:mt-0.8 sm-max:mt-0.4',
]);
